import React, { FC, useContext } from 'react'
import { ChatContext } from '~/service/chatConn'
import { FormType } from '.'
import { UseFormSetValue } from 'react-hook-form'

type AdditionalProps = {
  setValue: UseFormSetValue<FormType>
  redirectToStory?: number
  redirectToUser?: number
}

const Additional: FC<AdditionalProps> = ({
  setValue,
  redirectToStory,
  redirectToUser,
}) => {
  return (
    <div className="chat-input-additional">
      {redirectToStory && (
        <RedirectToStory
          setValue={setValue}
          redirectToStory={redirectToStory}
        />
      )}
      {redirectToUser && (
        <RedirectToUser setValue={setValue} redirectToUser={redirectToUser} />
      )}
    </div>
  )
}

export default Additional

//

type RedirectToStoryProps = {
  setValue: UseFormSetValue<FormType>
  redirectToStory: number
}

const RedirectToStory: FC<RedirectToStoryProps> = ({
  setValue,
  redirectToStory,
}) => {
  const { stories } = useContext(ChatContext)

  const story = stories.find(story => story.originId == redirectToStory)!

  return (
    <div className="chat-input-additional-redirect">
      <div>
        {intl.formatMessage({
          id: 'chat / input / redirect / label',
        })}{' '}
        <strong>{story.name}</strong>
      </div>

      <button
        className="chat-input-additional-redirect-remove"
        onClick={() => setValue('redirectToStory', undefined)}
      >
        <span className="fa fa-remove" />
      </button>
    </div>
  )
}

//

type RedirectToUserProps = {
  setValue: UseFormSetValue<FormType>
  redirectToUser: number
}

const RedirectToUser: FC<RedirectToUserProps> = ({
  setValue,
  redirectToUser,
}) => {
  const { usersOnRedirectList } = useContext(ChatContext)

  const selectedUser =
    usersOnRedirectList &&
    usersOnRedirectList?.find(user => user.saasId == redirectToUser)

  return (
    <div className="chat-input-additional-redirect">
      <div>
        {intl.formatMessage({
          id: 'chat / input / redirect / label',
        })}{' '}
        <strong>{selectedUser && selectedUser.userData.name}</strong>
      </div>

      <button
        className="chat-input-additional-redirect-remove"
        onClick={e => {
          setValue('redirectToUser', undefined)
        }}
      >
        <span className="fa fa-remove" />
      </button>
    </div>
  )
}
